import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Placeholder } from "rsuite";
import styles from "../master.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPen, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import { Link } from "react-router-dom";
const columns = [
  {
    name: "S.No",
    selector: "srNo",
    sortable: false,
  },
  {
    name: "Company Name",
    selector: "companyName",
    sortable: false,
  },
  {
    name: "State",
    selector: "registeredState",
    sortable: false,
  },
  {
    name: "City",
    selector: "registeredCity",
    sortable: false,
  },
  {
    name: "Information",
    selector: (row) => `${row.created_by} ${row.created_at}`,
    sortable: false,
    grow: 2,
  },
  {
    name: "Action",
    // selector: "info",
    sortable: false,
    cell: (record) => {
      return (
        <div>
          <span className="tableActionEdit">
            <Link to={`/masters/landlord/${record.id}`}>
              {" "}
              <FontAwesomeIcon icon={faPen} />
            </Link>
          </span>
          {/* <span className="tableActionDelete">
            <FontAwesomeIcon icon={faTimes} />
          </span> */}
        </div>
      );
    },
  },
];

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <ClearButton type="button" onClick={() => { DownloadFile(filterText) }} className="download_button">
      {/* <FontAwesomeIcon icon={faFileExcel} /> */}
      Download
    </ClearButton>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>
    {/* <a href={`${apiUrl.apiUrl.url}/landlord/index?term=${filterText}&export=true`}> */}
    {/* </a> */}
  </>
);
function DownloadFile(filterText) {
  // var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');  
  var self = this;
  axios({
    method: "post",
    url: `${apiUrl.apiUrl.url}/landlord/index?term=${filterText}&export=true&sendLink=true`,
    // data: columnsList,
  }).then(function (response) {
    window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
  });

}

const Table = () => {
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  React.useEffect(() => {
    fetchUsers(1);
  }, [filterText]);


  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchUsers = async (page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/landlord/index?page=${page}&per_page=${perPage}&delay=1&term=${filterText}`
    );
    // console.log(response, "res");
    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };


  const handlePageChange = (page) => {
    fetchUsers(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/landlord/index?page=${page}&per_page=${newPerPage}&delay=1`
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  return (
    <div className="tableContainer">
      <DataTable
        
        columns={columns}
        data={data}
        customStyles={datatableOptions.datatableOptions.customStyle}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        onChangePage={handlePageChange}
        paginationComponentOptions={
          datatableOptions.datatableOptions.paginationOptions
        }
      />
    </div>
  );
};
export default Table;
